<template>
	<div class="bar-chart">
		<canvas class="bar-chart__chart" :id="`js_barChart${chartIndex}`"></canvas>
		<p class="bar-chart__unit">{{ xUnit }}</p>
	</div>
</template>

<script>
import Chart from 'chart.js/auto'

const WEEK_DAY = ['日', '月', '火', '水', '木', '金', '土']

export default {
	name: 'BarChart',
	props: {
		labels: {
			type: Array,
			required: true
		},
		datapoints: {
			type: Array,
			required: true
		},
		chartIndex: {
			type: Number,
			required: true
		},
		displayType: {
			type: String,
			required: true
		},
		chartType: {
			type: String,
			required: true
		},
		xUnit: {
			type: String,
			required: true
		},
		chartBarsColor: {
			type: Array,
			default: null,
			required: false
		}
	},
	data () {
		return {
			barChart: null
		}
	},
	mounted () {
		// console.log(this.labels)
		// console.log(this.datapoints)
		// console.log(this.chartIndex)
		// console.log(this.displayType)
		// console.log(this.chartType)
		// console.log(this.xUnit)
		this.initChart()
	},
	methods: {
		initChart () {
			// グラフ描画コンテキスト取得
			const ctx = document.getElementById(`js_barChart${this.chartIndex}`)

			// ラインチャートの設定
			const data = {
				labels: this.labels,
				datasets: [
					{
						label: '',
						data: this.datapoints,
						backgroundColor: this.chartBarsColor ? this.chartBarsColor : '#8EDBEC'
					}
				]
			}

			// X軸の表示数を設定
			const xCount = this.displayType === 'week' ? 7 : 5

			// Y軸の最大値を設定
			// console.log('datapoints: ', this.datapoints)
			// const max = this.datapoints.length > 0 ? Math.max(...this.datapoints.filter(value => value !== null)) : this.chartType === 'walking-log' ? 2 : 60
			let max = Math.max(...this.datapoints.filter(value => value !== null))
			if (!isFinite(max) || max === 0) max = this.chartType === 'walking-dustance-log' ? 2 : 60

			const config = {
				type: 'bar',
				data: data,
				options: {
					responsive: true,
					maintainAspectRatio: false,
					scales: {
						x: {
							ticks: {
								count: xCount,
								maxTicksLimit: xCount,
								maxRotation: 0,
								minRotation: 0,
								color: '#4C4C4C',
								callback: (value, index, values) => {
									// typeがdayの場合、X軸ラベルは6時間刻みで最後は23時にする
									if (this.displayType === 'day') {
										if (index === 0 || index === 6 || index === 12 || index === 18) {
											return `${index}時`
										} else if (index === values.length - 1) {
											return `${index}時`
										}
									} else if (this.displayType === 'week') {
										return WEEK_DAY[index]
									} else if (this.displayType === 'month') {
										return `${index + 1}日`
									} else if (this.displayType === 'year') {
										if (index === 0 || index === 3 || index === 6 || index === 9 || index === 11) return `${index + 1}月`
									}
								}
							},
							grid: {
								display: false
							}
						},
						y: {
							ticks: {
								count: 3,
								maxTicksLimit: 3,
								color: '#4C4C4C',
								precision: 1,
								callback: (value) => {
									return value.toString().replace(/(\.\d*?[1-9])0+$/g, '$1').replace(/\.0+$/, '')
								}
							},
							grid: {
								color: '#E6E6E6',
								borderColor: 'transparent'
							},
							beginAtZero: true,
							max: max,
							min: 0
						}
					},
					plugins: {
						legend: {
							display: false
						},
						tooltip: {
							enabled: false
						}
					},
					animation: false
				}
			}

			// チャートのフォントを設定
			Chart.defaults.font.size = 10
			Chart.defaults.font.family = `'M+ C Type-1 (basic latin) Regular'`
			// Chart.defaults.borderColor = '#DFECFF'

			// チャートの描画
			// eslint-disable-next-line no-unused-vars
			this.barChart = new Chart(ctx, config)
		}
	}
}
</script>

<style lang="scss" scoped>
@import "../../assets/sass/variable";

// NOTE: デザインシステム外のため他での利用禁止

.bar-chart {
	position: relative;
	width: 100%;
	height: 160px;

	&__unit {
		position: absolute;
		bottom: $spacing-10;
		left: -$spacing-2;
		margin: 0;
		font-size: $font-size-8;
		transform: rotate(0.05deg);	// mplusのジャギー対策
	}
}
</style>
